import { defineStore } from 'pinia';
import { ref, computed, reactive } from 'vue';
import { StoreNames } from '@/app/shared/store-names';
import { useUiStateAutoPersist, useUiStatesApi } from '@/app/modules/ui-states';
const UI_STATES_KEY = StoreNames.OnboardingHints;

export const useOnboardingHintsStore = defineStore(UI_STATES_KEY, () => {
  const api = useUiStatesApi();

  const activeHints = reactive({
    dataCenterUploadsView: true,
    allocationsGroupsView: true,
  });

  const fetching = ref(false);
  const fetched = ref(false);

  let fetchingPromise: Promise<void> | null = null;

  async function fetch(force = false) {
    if (fetched.value && !force) {
      return fetchingPromise ?? Promise.resolve();
    }

    if (!fetchingPromise) {
      fetchingPromise = (async () => {
        fetching.value = true;

        const persistedState = await api
          .getUiStates({ key: UI_STATES_KEY })
          .then(({ data }) => data.data[0]);

        if (persistedState?.value.activeHints) {
          const hints = Object.keys(activeHints).reduce(
            (acc, key) => {
              if (key in persistedState.value.activeHints) {
                acc[key] = !!persistedState.value.activeHints[key];
              }
              return acc;
            },
            {} as Record<string, boolean>,
          );

          Object.assign(activeHints, hints);
        }

        fetching.value = false;
        fetched.value = true;
        fetchingPromise = null;
      })();

      return fetchingPromise;
    }

    return fetchingPromise;
  }

  const persistingValue = computed(() => ({
    activeHints: {
      ...activeHints,
    },
  }));

  useUiStateAutoPersist({
    enabled: fetched,
    value: persistingValue,
    key: UI_STATES_KEY,
  });

  return {
    fetching,
    fetched,
    fetch,
    activeHints,
  };
});
